<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="3" :xs="12">
          <el-form-item prop="id">
            <el-input v-model="params.id" placeholder="请输入车辆编号" />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="rfCardId">
            <el-input v-model="params.rfCardId" placeholder="请输入射频卡号" />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="phone">
            <el-input
              v-model="params.phone"
              placeholder="请输入手机号"
              :disabled="params.state == '9' || params.state == '10'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="cardNum">
            <el-input
              v-model="params.cardNum"
              maxlength="8"
              placeholder="请输入电卡/虚拟卡号"
              :disabled="params.state == '9' || params.state == '10'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="carportName">
            <el-input
              v-model="params.carportName"
              placeholder="请输入车库名称"
            />
          </el-form-item>
          <!-- <el-form-item prop="deviceId">
            <el-select
              v-model="params.carportId"
              id="el-select"
              :remote-method="adminSearchCarportByName"
              filterable
              placeholder="请输入车库名称"
              remote
              reserve-keyword
            >
              <el-option
                v-for="(item, index) in carportList"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item> -->
        </el-col>
        <!-- <el-col :span="3" :xs="12">
          <el-form-item prop="shareCode">
            <el-input
              v-model="params.shareCode"
              maxlength="11"
              placeholder="请输入分享码"
            />
          </el-form-item>
        </el-col> -->

        <el-col :span="2" :xs="12">
          <el-form-item prop="state">
            <el-select
              v-model="params.state"
              placeholder="状态"
              @change="handleStatusSelectChange"
            >
              <el-option
                v-for="item in status"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>

    <el-row
      style="margin-bottom: 10px"
      class="xs-mp-10"
      type="flex"
      justify="space-between"
      :gutter="5"
    >
      <el-col :span="3" :xs="12">
        <el-button type="primary" @click="handleCreateCarBtnClick"
          >创建车辆</el-button
        ></el-col
      >
      <el-col :span="3" :xs="12">
        <el-button
          type="primary"
          icon="el-icon-upload2"
          @click="handleExportTableBtnClick"
          >导出</el-button
        >
      </el-col>
    </el-row>

    <el-table
      id="exportTab"
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
      :default-sort="{ prop: 'id', order: 'descending' }"
    >
      <el-table-column label="车辆编号" prop="id" width="85" />
      <el-table-column label="车主名称" prop="name" width="110">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="scope.row.name"
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.name }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="手机号" width="130">
        <template #default="scope">
          {{
            scope.row.memberInfo && scope.row.memberInfo.phone > "0"
              ? scope.row.memberInfo.phone
              : "未绑定"
          }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="分享码" prop="shareCode" width="100" /> -->
      <el-table-column label="关联卡号" width="160">
        <template #default="scope">
          {{
            scope.row.card
              ? `${scope.row.card.cardId} (电卡)`
              : `${String(scope.row.memberId).padStart(8, "0")} (虚拟卡)`
          }}
        </template>
      </el-table-column>
      <el-table-column label="车库名称" width="130">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="
              (scope.row.carport ? scope.row.carport.name : '车库已取消') +
              '(' +
              (scope.row.carType ? scope.row.carType.name : '车辆类型已解绑') +
              ')'
            "
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{ scope.row.carport ? scope.row.carport.name : "车库已取消" }}
              (
              {{
                scope.row.carType ? scope.row.carType.name : "车辆类型已解绑"
              }}
              )
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="射频卡"
        width="110"
        prop="rfidCard.cardId"
        align="center"
      ></el-table-column>
      <!-- <el-table-column label="车辆类型" width="120">
        <template #default="scope">
          <el-tooltip
            effect="dark"
            :content="
              scope.row.carType ? scope.row.carType.name : '车辆类型已解绑'
            "
            placement="top-start"
          >
            <div class="text_ellipsis_1">
              {{
                scope.row.carType ? scope.row.carType.name : "车辆类型已解绑"
              }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column> -->

      <el-table-column label="充电包月(元)" width="100" align="center">
        <template #default="scope">
          {{ scope.row.monthlyInfo ? scope.row.monthlyInfo.money : 0 }}
        </template>
      </el-table-column>

      <el-table-column label="停车包月(元)" width="100" align="center">
        <template #default="scope">
          {{ scope.row.carType ? scope.row.carType.monthlyCharge : 0 }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="车棚(类型)" min-width="100">
        <template #default="scope">
          {{ scope.row.carport ? scope.row.carport.name : "车棚已取消" }}({{
            scope.row.carType ? scope.row.carType.name : "车辆类型已解绑"
          }})
        </template>
      </el-table-column> -->

      <!--      <el-table-column label="楼号-单元号-房号" min-width="150" >-->
      <!--        <template #default="scope">-->
      <!--          {{ scope.row.building }}-{{ scope.row.unitNumber }}-{{ scope.row.houseNumber }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="车辆图片" width="120" align="center">
        <template #default="scope">
          <el-image
            style="width: 80px; height: 80px"
            :src="getCarFullImg(scope)"
            :preview-src-list="getCarPreviewList(scope)"
            fit="fit"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="车辆图片" width="120" align="center">
        <template #default="scope">
          <el-image
            style="width: 80px; height: 80px"
            :src="getCarLeftImg(scope)"
            :preview-src-list="getCarPreviewList(scope)"
            fit="fit"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="充电到期" width="100" align="center">
        <template #default="scope">
          {{
            scope.row.memberMonthly
              ? parseFormatDay(new Date(scope.row.memberMonthly.endTime * 1000))
              : "未开通"
          }}
        </template>
      </el-table-column>
      <el-table-column label="停车到期" width="100" align="center">
        <template #default="scope">
          {{
            scope.row.carportMemberMonthly
              ? parseFormatDay(
                  new Date(scope.row.carportMemberMonthly.endTime * 1000)
                )
              : "未开通"
          }}
        </template>
      </el-table-column>

      <el-table-column label="状态" width="100" align="center">
        <template #default="scope">{{ getCarState(scope.row) }}</template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="250">
        <template #default="scope">
          <!-- <el-button
            v-if="scope.row.memberMonthly || scope.row.carportMemberMonthly"
            size="mini"
            @click="clickEditEndLine(scope.row)"
          >
            修改结束日期
          </el-button> -->
          <!-- <el-button
            size="mini"
            type="primary"
            v-if="scope.row.state === 0"
            @click="agentCheckCar(scope.row.id)"
            >通过
          </el-button>
          <el-button
            size="mini"
            type="danger"
            v-if="scope.row.state === 0"
            @click="agentRejectCar(scope.row.id)"
            >驳回
          </el-button> -->
          <template v-if="scope.row.state === 1">
            <el-button
              size="mini"
              type="primary"
              @click="handleOpenMonthlyBtnClick(scope.row)"
              >代开包月</el-button
            >
            <el-button size="mini" type="danger" @click="disable(scope.row.id)"
              >禁用
            </el-button>
            <el-button
              v-if="!scope.row.rfidCard"
              size="mini"
              type="warning"
              @click="RFCard(scope.row.id)"
              >射频卡
            </el-button>
          </template>

          <el-button
            size="mini"
            type="primary"
            v-if="scope.row.state === -1"
            @click="enable(scope.row.id)"
            >启用
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total" />
    <disable-member-car :device-id="deviceId" :dialog="agentCancelDialog" />
    <enable-member-car :device-id="deviceId" :dialog="showEnableMemberDialog" />
    <show-agent-reject-car :device-id="deviceId" :dialog="showAgentRejectCar" />
    <show-agent-check-car :device-id="deviceId" :dialog="showAgentCheckCar" />
    <create-car-dialog
      v-if="createCarDialog"
      :dialog="createCarDialog"
      @finish="handleCreateCarFinish"
    />
    <el-dialog
      width="20%"
      :visible.sync="editEndLineDialogState"
      title="修改包月日期"
    >
      <el-form
        ref="editEndLineParams"
        :model="editEndLineParams"
        label-width="auto"
      >
        <el-form-item label="手机号">
          <el-input v-model="chooseItem.phone" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="充电到期日期" v-if="chooseItem.memberMonthly">
          <el-date-picker
            v-model="chargeEndLine"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            placeholder="充电到期日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="停车到期日期"
          v-if="chooseItem.carportMemberMonthly"
        >
          <el-date-picker
            v-model="chooseEndLine"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            placeholder="停车到期日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editEndLineDialogState = false">取消</el-button>
        <el-button type="primary" @click="editEndLineDo">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="open_month_dialog"
      width="22%"
      :visible.sync="openMonthlyDialog"
      title="代开包月"
      @close="handleOpenMonthDialogClose"
      :fullscreen="isMobile"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        ref="openMonthlyDialogRef"
        :model="openMonthlyDialogForm"
        :rules="openMonthlyDialogRules"
        label-width="auto"
      >
        <el-form-item label="车辆编号" v-if="currentCar">
          <span>{{ currentCar.id }}</span>
        </el-form-item>
        <el-form-item label="包月类型" prop="monthlyType">
          <el-select
            v-model="openMonthlyDialogForm.monthlyType"
            placeholder="请选择包月类型"
          >
            <el-option
              v-for="item in monthlyTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="包月数量"
          v-if="currentCar && openMonthlyDialogForm.monthlyType"
        >
          <el-input-number
            v-model="openMonthlyDialogForm.openMonthNum"
            :min="1"
            :max="12"
          ></el-input-number>
          个月
        </el-form-item>
        <el-form-item
          label="停车包月"
          v-if="currentCar && openMonthlyDialogForm.monthlyType"
        >
          <span
            >{{
              currentCar.carType.monthlyCharge *
                openMonthlyDialogForm.openMonthNum || 0
            }}元</span
          >
        </el-form-item>
        <el-form-item
          label="充电包月"
          v-show="openMonthlyDialogForm.monthlyType === 1"
        >
          <span>{{
            chargeMonthlyInfo.money * openMonthlyDialogForm.openMonthNum +
            "元" +
            " \/ " +
            chargeMonthlyInfo.freeChargeNum *
              openMonthlyDialogForm.openMonthNum +
            "小时，最大功率" +
            chargeMonthlyInfo.endPower +
            "W"
          }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="openMonthlyDialog = false">取消</el-button>
        <el-button type="primary" @click="handleOpenMonthlyDialogConfirm"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 绑定射频卡弹框 -->
    <el-dialog
      width="30%"
      :fullscreen="dialogFullscreen"
      :visible.sync="showRFCardPopup"
      title="绑定射频卡"
    >
      <div class="bind_rf">
        <div class="rf_car">车辆编号：{{ bindRFCarId }}</div>
        <div class="rf_card">
          射频卡号：
          <el-select
            v-model="bindRFCardId"
            placeholder="请输入射频卡号"
            filterable
            ref="select"
            @focus="closeReadOnly"
            @hook:mounted="closeReadOnly"
            @visible-change="closeReadOnly"
            remote
            reserve-keyword
            :remote-method="remoteGetCardMethod"
            :loading="loading2"
          >
            <el-option
              v-for="item in cardList"
              :key="item.cardId"
              :label="item.cardId"
              :value="item.cardId"
            />
          </el-select>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="showRFCardPopup = false">取消</el-button>
        <el-button type="primary" @click="handleBindRFCard">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CarPort from "@/api/device/CarPort";
import CarportMemberMonthlyApi from "@/api/device/CarportMemberMonthlyApi";
import UserCar from "@/api/device/UserCar";
import agentGetMonthlyInfoById from "@/api/device/monthly-manage/agentGetMonthlyInfoById";
import agentGetChildAgent from "@/api/user/agent-manage/agentGetChildAgent";
import agentBindRFIDCard from "@/api/user/card-manage/agentBindRFIDCard";
import agentGetRFIDCardListByCarIdList from "@/api/user/card-manage/agentGetRFIDCardListByCarIdList";
import createCarDialog from "@/components/Dialog/createCarDialog";
import Page from "@/components/Page";
// import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import formatPhone from "@/mixin/formatPhoneMixin";
import getDeviceMixin from "@/mixin/getDeviceMixin";
import isMobileMixin from "@/mixin/isMobileMixin";
import pageMixin from "@/mixin/pageMixin";
import resDispose from "@/mixin/resDisposeMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
import { exportTableToExcel } from "@/utils/exportTable";
import { debounce } from "@/utils/utils";
import { Loading, Message } from "element-ui";
import DisableMemberCar from "./comments/DisableMemberCar";
import EnableMemberCar from "./comments/EnableMemberCar";
import ShowAgentCheckCar from "./comments/ShowAgentCheckCar";
import ShowAgentRejectCar from "./comments/ShowAgentRejectCar";

export default {
  name: "AllUserCar",
  components: {
    DisableMemberCar,
    EnableMemberCar,
    Page,
    ShowAgentCheckCar,
    ShowAgentRejectCar,
    createCarDialog,
  },
  mixins: [
    searchMixin,
    pageMixin,
    // createdMixin,
    resDispose,
    dialogMixin,
    timeMixin,
    getDeviceMixin,
    isMobileMixin,
  ],
  data() {
    return {
      loadTable: false,
      openMonthlyDialog: false,
      openMonthlyDialogForm: {
        monthlyType: undefined,
        openMonthNum: 1,
      },
      monthlyTypeList: [],
      chargeMonthlyInfo: {},
      openMonthlyDialogRules: {
        monthlyType: [{ required: true, message: "请选择包月类型" }],
      },
      currentCar: null,
      carportList: [],
      state: {
        1: "正常",
        // 0: "待审核",
        "-1": "禁用",
        "-2": "驳回",
        "-3": "已注销",
      },
      status: [
        // { value: "1", label: "正常" },
        // { value: "0", label: "待审核" },
        { value: "-1", label: "禁用" },
        { value: "-2", label: "驳回" },
        { value: "-3", label: "已注销" },
        { value: "9", label: "包月中" },
        { value: "10", label: "包月过期" },
      ],
      load: false,
      VUE_APP_IMG_FILE_BASE: process.env.VUE_APP_IMG_FILE_BASE,
      agentCancelDialog: false,
      showEnableMemberDialog: false,
      showAgentRejectCar: false,
      showAgentCheckCar: false,
      params: {
        id: "",
        rfCardId: "",
        cardNum: "",
        carportName: "",
        name: "",
        phone: "",
        state: "",
        shareCode: "",
        sortName: "id",
        sortType: "DESC",
      },
      records: [],
      deviceId: undefined,
      options: [],
      editEndLineParams: {
        endLine: "",
        chargeEndLine: "",
        memberMonthlyId: "",
      },
      chooseItem: {
        phone: "",
      },
      editEndLineDialogState: false,
      chargeEndLine: "",
      chooseEndLine: "",
      createCarDialog: false,
      showRFCardPopup: false,
      bindRFCarId: "",
      bindRFCardId: "",
      loading2: false,
      cardList: [],
    };
  },
  watch: {
    "params.phone": {
      handler() {
        this.params.phone = formatPhone(this.params.phone);
      },
    },
    "params.cardNum": {
      handler(newV) {
        if (!newV) return;
        this.params.cardNum = newV.trim();
      },
    },
  },
  created() {
    if (this.$route.query.id) {
      this.params.id = this.$route.query.id;
    }
    this.fetchData();
  },
  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    handleBindRFCard() {
      console.log("绑定射频卡确定", this.bindRFCarId, this.bindRFCardId);
      if (!this.bindRFCardId) {
        return Message.error("请先输入射频卡号~");
      }

      // 绑定射频卡接口
      agentBindRFIDCard({
        cardId: this.bindRFCardId,
        carId: this.bindRFCarId,
      }).then((res) => {
        if (res.code == 1) {
          Message.success("绑定成功~");
          this.showRFCardPopup = false;
          this.fetchData();
        } else {
          Message.error(res.msg);
        }
      });
    },
    remoteGetCardMethod: debounce(function (query) {
      if (query !== "") {
        this.loading2 = true;
        agentGetRFIDCardListByCarIdList({
          cardId: query,
          pageNum: 1,
          size: 999,
        }).then((res) => {
          this.loading2 = false;
          this.cardList = res.data.records.map((r) => ({
            ...r,
            cardId: r.cardId.padStart(8, "0"),
          }));
        });
      } else {
        this.cardList = [];
      }
    }, 500),
    // 获取车辆状态
    getCarState(row) {
      if (row.state == 1) {
        // 未开包月
        if (!row.memberMonthly && !row.carportMemberMonthly) {
          return "未开包月";
        }
        const maxEndTime = Math.max(
          row.memberMonthly ? row.memberMonthly.endTime : 0,
          row.carportMemberMonthly ? row.carportMemberMonthly.endTime : 0
        );
        // 包月中 或 包月过期
        return maxEndTime * 1000 > Date.now() ? "包月中" : "包月过期";
      } else {
        return this.state[row.state];
      }
    },
    handleExportTableBtnClick() {
      exportTableToExcel(
        "exportTab",
        ["充电包月(元)", "停车包月(元)"],
        "车辆管理.xlsx"
      );
    },
    // 点击代开包月按钮时触发
    handleOpenMonthlyBtnClick(row) {
      if (!row.carType) {
        return Message.error("车辆类型已解绑,无法包月~");
      }

      this.currentCar = row;

      // 只停车
      if (row.carType.chargeMonthlyInfoId === 0) {
        this.monthlyTypeList = [{ value: 2, label: "只停车" }];
        this.openMonthlyDialog = true;
        return;
      }

      // 获取车辆类型包月套餐中的充电包月信息
      agentGetMonthlyInfoById(row.carType.chargeMonthlyInfoId).then((res) => {
        if (res.data) {
          this.monthlyTypeList = [
            { value: 1, label: "充电+停车" },
            { value: 2, label: "只停车" },
          ];
          this.chargeMonthlyInfo = res.data;
        } else {
          this.monthlyTypeList = [{ value: 2, label: "只停车" }];
        }
        this.openMonthlyDialogForm.openMonthNum = 1;
        this.openMonthlyDialog = true;
      });
    },
    handleOpenMonthDialogClose() {
      this.$refs["openMonthlyDialogRef"].resetFields();
    },
    // 确认代开包月
    handleOpenMonthlyDialogConfirm() {
      this.$refs["openMonthlyDialogRef"].validate((valid) => {
        if (valid) {
          let loadingInstance = Loading.service({
            target: ".open_month_dialog",
            background: "rgba(0,0,0,0.6)",
            fullscreen: false,
            text: "开通中",
          });

          CarportMemberMonthlyApi.agentCreatMonthlyOfCarport({
            carId: this.currentCar.id,
            monthlyInfoId:
              this.openMonthlyDialogForm.monthlyType == 1
                ? this.currentCar.carType.chargeMonthlyInfoId
                : undefined,
            openMonthNum: this.openMonthlyDialogForm.openMonthNum,
          }).then((res) => {
            console.log(res, 5666);

            loadingInstance.close();

            if (res.code == 1) {
              Message.success("代开包月成功~");
              this.openMonthlyDialog = false;
              this.fetchData();
            } else {
              Message.error(res.msg);
            }
          });
        }
      });
    },
    handleCreateCarFinish() {
      this.createCarDialog = false;
      this.fetchData();
    },
    // 点击创建车辆按钮时触发
    handleCreateCarBtnClick() {
      this.createCarDialog = true;
    },
    getCarFullImg(scope) {
      try {
        return process.env.NODE_ENV === "development"
          ? require("D://www/wwwroot/file.hc17888.com" + scope.row.fullFaceImg)
          : this.VUE_APP_IMG_FILE_BASE + scope.row.fullFaceImg;
      } catch (e) {
        return "";
      }
    },
    getCarLeftImg(scope) {
      try {
        return process.env.NODE_ENV === "development"
          ? require("D://www/wwwroot/file.hc17888.com" + scope.row.leftImg)
          : this.VUE_APP_IMG_FILE_BASE + scope.row.leftImg;
      } catch (e) {
        return "";
      }
    },
    getCarPreviewList(scope) {
      try {
        return process.env.NODE_ENV === "development"
          ? [
              require("D://www/wwwroot/file.hc17888.com" +
                scope.row.fullFaceImg),
              require("D://www/wwwroot/file.hc17888.com" + scope.row.leftImg),
            ]
          : [
              this.VUE_APP_IMG_FILE_BASE + scope.row.fullFaceImg,
              this.VUE_APP_IMG_FILE_BASE + scope.row.leftImg,
            ];
      } catch (e) {
        return [];
      }
    },
    resetFields() {
      this.carportList = [];
      // this.params.carportId = undefined;
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }

      this.fetchData();
    },
    clickEditEndLine(row) {
      this.chooseItem = row;
      this.editEndLineParams.memberMonthlyId = row.carportMemberMonthly.id;
      this.editEndLineDialogState = true;
      console.log(row);
      if (row.carportMemberMonthly)
        this.chooseEndLine = new Date(row.carportMemberMonthly.endTime * 1000);
      if (row.memberMonthly)
        this.chargeEndLine = new Date(row.memberMonthly.endTime * 1000);
    },
    editEndLineDo() {
      if (this.chooseEndLine)
        this.editEndLineParams.endLine = this.chooseEndLine.getTime() / 1000;
      if (this.chargeEndLine)
        this.editEndLineParams.chargeEndLine =
          this.chargeEndLine.getTime() / 1000;
      CarportMemberMonthlyApi.agentEditMemberMonthlyEndLine(
        this.editEndLineParams
      ).then((res) => {
        this.resFetch({ res });
        this.editEndLineDialogState = false;
      });
    },
    fetchData() {
      this.loadTable = true;
      UserCar.agentGetAllMemberCarByPage(this.params, this.current, this.size)
        .then((res) => {
          // console.log(res.data.records)
          this.records = res.data.records;
          this.total = res.data.total;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
    RFCard(id) {
      this.bindRFCarId = id;
      this.cardList = [];
      this.bindRFCardId = "";
      this.showRFCardPopup = true;
    },
    disable(id) {
      this.agentCancelDialog = true;
      this.deviceId = id;
    },
    enable(id) {
      this.showEnableMemberDialog = true;
      this.deviceId = id;
    },
    agentRejectCar(id) {
      this.showAgentRejectCar = true;
      this.deviceId = id;
    },
    agentCheckCar(id) {
      this.showAgentCheckCar = true;
      this.deviceId = id;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.load = true;
        agentGetChildAgent({ name: query }).then((res) => {
          this.options = res.data;
          this.load = false;
        });
      } else {
        this.options = [];
      }
    },
    adminSearchCarportByName(name) {
      CarPort.searchCarportByName({ name: name }).then((res) => {
        this.getDataResDispose({
          res,
          success: () => {
            this.carportList = res.data;
          },
        });
      });
    },
    handleStatusSelectChange(e) {
      if (e == "9" || e == "10") {
        this.params.phone = "";
        this.params.cardNum = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.bind_rf {
  .rf_car {
    margin-bottom: 20px;
  }
  .rf_card {
  }
}
</style>
